import EventBus from '../EventBus';

// More declarative and shorter way to create notifications
// @param {string(html)} message - Notification message
// @param {object} options:
//      cb {function} - if cb specified, generates special notification with yes/no type and then initialised cb with
//      true/false param
// @return {void}

const addNotification = (message, type, options) => {
    EventBus.$emit('AddNewNotification', message, type, options)
};

const addSuccesNotification = (message, options) => {
    addNotification(message, 'success', options)
};

const addInfoNotification = (message, options) => {
    addNotification(message, 'info', options)
};

const addErrorNotification = (message, options) => {
    addNotification(message, 'error', options)
};

export {
    addNotification,
    addSuccesNotification,
    addInfoNotification,
    addErrorNotification
}



// WEBPACK FOOTER //
// ./src/utils/notifications.js